module.exports = __webpack_public_path__ + "assets/img/hd.4bdc0285.png";